<template>
  <UApp>
    <NavigationHeader />
    <UMain>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UMain>
    <NavigationFooter />
  </UApp>
</template>
